<template>
    <div class="container" v-bind:class="{'is-fluid': fullWidth ==true }">

        <label v-if="showImage" class="heading">Close Image</label>
        <label v-else class="heading">Open Image</label>
        <div class="columns">
            <div v-if="!showImage" class="column">
                <font-awesome-icon icon="arrow-alt-circle-down" size="2x"
                                   @click="showImage=true"/>
            </div>
            <div v-else class="column">
                <font-awesome-icon icon="arrow-alt-circle-up" size="2x"
                                   @click="showImage=false"/>
            </div>
        </div>
        <div>
            <figure v-if="showImage" class="image is-2by1 animate__animated animate__fadeInDown">
                <img src="../../../assets/images/IcaoMapP.png" height="943" width="1897"/></figure>
        </div>

        <div class="box">
            <div class="level">

                <div class="level-left">
                    <div class="level-item">

                        <div class="control">
                           <!-- :oninput="GetInputText(searchText_Userin)" -->
                            <input class="box-info-search input" type="text"  v-model="searchText_Userin"  placeholder="Filter in table">
                        </div>

                        <div class="level-item">
                            <button @click="GetInputText(searchText_Userin)" class="button is-info" type="button">Search</button>
                        </div>

                    </div>
                </div>

                <div class="level-right">
                    <div class="level-item">
                        <div class="field">
                            <button class="create-button button" @click="openCloseModal">
                                  <span class="icon is-small">
                                      <i class="fas fa-plus-circle"></i>
                                  </span>
                                <span>Create</span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can add a new airport</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can delete airport</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can update airport</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can view the airports on the grid.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can search airport by EGS</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can see Active and All Airports</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">Airports are updated with Netline integration. There is a case of deletion and updating of the airport determined by Netline.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tabs is-centered">
            <ul>
                <li :class="showActiveairports ? 'is-active':''" @click="GetActiveAirports()"><a>Active Airports</a></li>
                <li :class="showallairports ? 'is-active':''" @click="GetFullAirports()"><a>All Airports</a></li>
            </ul>
        </div>

        <div v-if="showActiveairports">
            <div class="notification">
                <div v-if="!isLoading" class="airports-table">
                    <table class="table is-hoverable is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp animate__faster">
                        <thead>
                        <tr>
                            <th colspan="12">AIRPORTS</th>
                        </tr>
                        <tr>
                            <th colspan="8">Defined By EFF</th>
                            <th colspan="4">Defined By Netline</th>
                        </tr>
                        <tr>
                            <th>Id</th>
                            <th>Iata</th>
                            <th>Icao</th>
                            <th>Category</th>
                            <th>Location Name</th>
                            <th>Name</th>
                            <th>Country</th>
                            <th>Action</th>
                            <th>Icao</th>
                            <th>Category</th>
                            <th>Country</th>
                            <th>Airport Name</th>
                        </tr>
                        </thead>

                        <tbody v-if="paginate && paginate.length">
                        <tr v-for="airport in paginate" :key="airport.iata" :style="{backgroundColor : (airport.icao == '')?'#F15140':'white'}">
                            <td>{{airport.id}}</td>
                            <td>{{airport.iata}}</td>
                            <td>{{airport.icao}}</td>
                            <td>{{airport.category}}</td>
                            <td>{{airport.locationName}}</td>
                            <td>{{airport.name}}</td>
                            <td>{{airport.country}}</td>
                            <td>
                                <button title="Edit" class="button is-small is-light is-info"
                                        @click="editAirportList(airport.id,airport.iS_USED)">
                                    <font-awesome-icon icon="edit"/>
                                    Edit
                                </button>
                                <button title="Delete" class="button is-small is-light is-warning"
                                        @click="deleteAirportList(airport)">
                                    <font-awesome-icon icon="box"/>
                                    <p style="padding: 2px">Delete</p>
                                </button>
                            </td>
                            <td>{{airport.nICAO}}</td>
                            <td>{{airport.ncategory}}</td>
                            <td>{{airport.nCountryCode}}</td>
                            <td>{{airport.nAirportname}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <loading-button/>
                </div>
            </div>

            <div class="">
                <div class="level">
                    <nav class="pagination" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                                <div @click="setPage(1)" class="pagination-link">
                                    <a href="#">« First</a>
                                </div>
                            </li>
                            <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                                <div @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                    <a href="#" :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']" >{{ pageNavigationInfo.start + index }}</a>
                                </div>
                            </li>
                            <li v-if="pageNavigationInfo.hasLastPageNavigation">
                                <div @click="setPage(pageNavigationInfo.total)" class="pagination-link">
                                    <a href="#">Last »</a>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

        </div>

        <div v-if="showallairports">
            <div class="notification">
                <div v-if="!isLoading" class="airports-table">
                    <table class="table is-hoverable is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp animate__faster">
                        <thead>
                        <tr>
                            <th colspan="12">AIRPORTS</th>
                        </tr>
                        <tr>
                            <th colspan="8">Defined By EFF</th>
                            <th colspan="4">Defined By Netline</th>
                        </tr>
                        <tr>
                            <th>Id</th>
                            <th>Iata</th>
                            <th>Icao</th>
                            <th>Category</th>
                            <th>Location Name</th>
                            <th>Name</th>
                            <th>Country</th>
                            <th>Action</th>
                            <th>Icao</th>
                            <th>Category</th>
                            <th>Country</th>
                            <th>Airport Name</th>
                        </tr>
                        </thead>
                        <tbody v-if="paginate && paginate.length">
                        <tr v-for="airport in paginate" :key="airport.iata" :style="{backgroundColor : (airport.icao == '')?'#F15140':'white'}">

                            <td>{{airport.id}}</td>
                            <td>{{airport.iata}}</td>
                            <td>{{airport.icao}}</td>
                            <td>{{airport.category}}</td>
                            <td>{{airport.locationName}}</td>
                            <td>{{airport.name}}</td>
                            <td>{{airport.country}}</td>

                            <td>
                                <button title="Edit" class="button is-small is-light is-info"
                                        @click="editAirportList(airport.id,airport.iS_USED)">
                                    <font-awesome-icon icon="edit"/>
                                    Edit
                                </button>
                                <button title="Delete" class="button is-small is-light is-warning"
                                        @click="deleteAirportList(airport)">
                                    <font-awesome-icon icon="box"/>
                                    <p style="padding: 2px">Delete</p>
                                </button>
                            </td>

                            <td>{{airport.nICAO}}</td>
                            <td>{{airport.ncategory}}</td>
                            <td>{{airport.nCountryCode}}</td>
                            <td>{{airport.nAirportname}}</td>

                        </tr>

                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <loading-button/>
                </div>
            </div>

            <div class="">
                <div class="level">
                    <nav class="pagination" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                                <div @click="setPage(1)" class="pagination-link">
                                    <a href="#">« First</a>
                                </div>
                            </li>
                            <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                                <div @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                    <a href="#" :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']" >{{ pageNavigationInfo.start + index }}</a>
                                </div>
                            </li>
                            <li v-if="pageNavigationInfo.hasLastPageNavigation">
                                <div @click="setPage(pageNavigationInfo.total)" class="pagination-link">
                                    <a href="#">Last »</a>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>

        <div class="modal" v-bind:class="{'is-active':isActiveModal}">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:50%; height: 50%;">
                <header class="modal-card-head">
                    <p class="modal-card-title">Airports</p>
                    <button class="delete is-large" @click="closeModal" aria-label="close">Close
                    </button>
                </header>
                <section class="modal-card-body" style="width: 100%; height: 100%">
                    <div>
                        <div class="field">
                            <label class="label">Iata</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.iata"
                                       class="input" type="text" placeholder="iata code" maxlength="3">
                                <input v-else v-model="addForm.iata" class="input" type="text" placeholder="iata code"
                                       maxlength="3">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Icao</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.icao"
                                       class="input" type="text" placeholder="icao code" maxlength="4">
                                <input v-else v-model="addForm.icao" class="input" type="text" placeholder="icao code"
                                       maxlength="4">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Category</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.category"
                                       class="input" type="text" placeholder="Category Name Ex. CAI,CXI" maxlength="4">
                                <input v-else v-model="addForm.category" class="input" type="text"
                                       placeholder="icao code"
                                       maxlength="4">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Country</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.country"
                                       class="input" type="text" placeholder="country" maxlength="12">
                                <input v-else v-model="addForm.country" class="input" type="text" placeholder="country"
                                       maxlength="2">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Location Name</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.locationName"
                                       class="input" type="text" placeholder="Location name" maxlength="15">
                                <input v-else v-model="addForm.locationName" class="input" type="text"
                                       placeholder="location name"
                                       maxlength="15">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label"> Name</label>
                            <div class="control">
                                <input v-if="UpdateAirportList.id != null" v-model="UpdateAirportList.name"
                                       class="input" type="text" placeholder="name" maxlength="15">
                                <input v-else v-model="addForm.name" class="input" type="text" placeholder="name"
                                       maxlength="15">
                            </div>
                        </div>
                    </div>

                </section>
                <footer class="modal-card-foot">
                    <div v-if="UpdateAirportList.id != null" class="field">
                        <div class="control">
                            <button class="create-button button" @click="TryUpdateAirport(UpdateAirportList)">
                                  <span class="icon is-small">
                                     <i class="fas fa-edit"></i>
                                  </span>
                                <span>Update</span>
                            </button>
                        </div>
                    </div>
                    <div v-else class="field">
                        <div class="control">
                            <button class="create-button button" @click="TryAddAirport(addForm)">
                                  <span class="icon is-small">
                                     <i class="fas fa-save"></i>
                                  </span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </footer>

            </div>
        </div>



    </div>

</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    import {loadingMixin} from "../../../utils/mixins";
    import LoadingButton from "../../../components/ui/LoadingButton";
    // import {Tabs, TabPane} from 'vue-bulma-tabs';

    const {mapState, mapActions} = createNamespacedHelpers('airport');
    export default {
        name: "Airports",
        mixins: [loadingMixin],
        components: {
            LoadingButton
        },

        data() {
            return {
                fullWidth: true,
                showImage: false,
                searchText: "",
                currentPage: 1,
                pageRange : 3,
                itemsPerPage: 200,
                resultCount: 0,
                pageNavigationInfo: {},
                searchText_Userin: "",
                showActiveairports : false,
                showallairports: false,
                AirportEditRequest:{id:0,isUsed:false},
                Airports:[],
                addForm: {
                    id: 0,
                    iata: "",
                    icao: "",
                    category: "",
                    country: "",
                    locationName: "",
                    name: "",
                }
            }
        },

        methods: {
            ...mapActions([
                "GetAirports",
                "openCloseModal",
                "GetAirportById",
                "AddAirport",
                "UpdateAirport",
                "deleteAirport"
            ]),

            async editAirportList(value,isUsed) {
                this.openCloseModal();

                this.AirportEditRequest.id = value;
                this.AirportEditRequest.isUsed = isUsed;
                await this.GetAirportById(this.AirportEditRequest);
            },

            async deleteAirportList(value){

                await this.$swal({
                    title: '<p style="text-align: left;font-size: 22px;">Do you want to delete airport?</p>',
                    html: "",
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) =>
                {
                    if (response.value)
                    {
                        await this.deleteAirport(value);
                        await this.TryGetAirports();
                        // this.$notify({
                        //     title: "Success",
                        //     text: "Airport is deleted.",
                        //     type: "success"
                        // });
                    }
                });

            },

            async GetActiveAirports()
            {
                this.showallairports = false;
                this.showActiveairports = true;

                this.showLoading();
                try {
                    var IsUsed = true;
                    this.GetAirports(IsUsed);  // sadece true lar için false göndericez isused parametresi olarak.
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on GetActiveAirports function, e: "+ e.message});
                } finally {
                    this.hideLoading();
                }

            },

            async GetFullAirports(){

                this.showallairports = true;
                this.showActiveairports = false;

                this.showLoading();
                try {
                    var IsUsed = false
                    this.GetAirports(IsUsed); // full için false göndericez isused parametresi olarak.
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text:"Error on GetFullAirports function e: " +e.message});
                } finally {
                    this.hideLoading();
                }

            },

            async TryGetAirports() {
                this.showLoading();
                try {
                    var IsUsed = false
                    this.GetAirports(IsUsed);
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text:"Error on TryGetAirports function e: " + e.message});
                } finally {
                    this.hideLoading();
                }
            },

            async TryUpdateAirport(value) {
                try {
                    await this.UpdateAirport(value)
                    this.closeModal();
                    //this.$notify({title: "Success", type: "success", text: "Succesfuly Update"})
                    console.log("TryUpdateAirport")
                    await this.TryGetAirports();
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryUpdateAirport function e: " +e.message})
                }
            },

            async TryAddAirport(value) {
                try {
                    await this.AddAirport(value)
                    this.closeModal();
                    //this.$notify({title: "Success", type: "success", text: "Succesfuly Adding"})
                    this.addForm = {};
                    console.log("TryAddAirport")
                    await this.TryGetAirports();
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryAddAirport function e: " +e.message})
                }
            },

            closeModal() {
                this.openCloseModal();
                this.addForm = {};
            },

            GetInputText(input)
            {
               /* let _t = false;
                if(_t)
                {
                    clearTimeout(_t);
                }
                _t = setTimeout(function (){

                }, 1000); */
                this.setPage(1);
                this.searchText = input;
            },

            setPage: function(pageNumber) {
                this.currentPage = pageNumber
                // this.paginateFunc();
                this.buildPageNavigationInfo()
            },

            setResultCount: function(count)
            {
                this.resultCount = count
            },

            setCurrentPage: function(currentPage)
            {
                this.currentPage = currentPage;
            },

            setAirportList: function(list)
            {
                this.Airports = list;
            },

            buildPageNavigationInfo() {

                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);

                this.pageNavigationInfo = {
                    start: firstPage-1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total : _total,
                }
            },

        },

        computed:
        {
            ...mapState([
                "AirportsList",
                "isActiveModal",
                "UpdateAirportList"
            ]),

            SearchTextComp:{
                get(){
                    return this.searchText.toUpperCase();
                },
                set()
                {

                }
            },

            totalPages : function () {
                return Math.ceil(this.resultCount / this.itemsPerPage);
            },

            paginate: function()
            {
                    if(!this.AirportsList || this.AirportsList.length ==0)
                    {
                        return 0;
                    }

                    this.setAirportList(this.AirportsList);

                    var list = this.Airports.filter(airport =>{
                        return airport.iata.toString().trim().match(this.searchText.toUpperCase().trim());})

                    this.setResultCount(list.length);

                    if (this.currentPage >= this.totalPages)
                    {
                        this.setCurrentPage(this.totalPages);
                    }

                    var index = this.currentPage * this.itemsPerPage - this.itemsPerPage
                    this.buildPageNavigationInfo()
                    return list.slice(index, index + this.itemsPerPage);
            },

        },

        async created() {
           await this.GetActiveAirports();
        }

    }
</script>

<style scoped>

    .th-text {
        text-align: center;
    }

    .font-awesome-icon {
        cursor: pointer;
    }

    .airports-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
        padding-top: 15px;
    }

    .airports-table td {
        border: 0px;
    }

    .airports-table {
        overflow-y: scroll;
        height: 700px;
    }

    .airports-table th {
        top: -12px;
        positiairports-tableon: sticky;
        background-color: white;
        z-index: 2;
        text-align: center;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    /*.airports-table {*/
    /*    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);*/
    /*    overflow-y: scroll;*/
    /*    height: 700px;*/
    /*}*/

    /*.airports-table th {*/
    /*    top: -12px;*/
    /*    position: sticky;*/
    /*    background-color: white;*/
    /*    z-index: 2;*/
    /*}*/

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }


    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
